var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_800_1664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9688 11.1881L15.9688 4.03116L12.335 7.68389V7.68389C13.6617 6.35013 15.939 7.27978 15.9533 9.16098L15.9688 11.1881Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9688 4.03116L11.1975 4.03116L8.81185 4.03116L10.8271 4.03845C12.7253 4.04533 13.6737 6.33819 12.335 7.68389V7.68389L15.9688 4.03116Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55433 14.4456L12.335 7.68389M15.9688 4.03116L11.1975 4.03116L8.81185 4.03116M15.9688 4.03116L15.9688 11.1881M15.9688 4.03116L12.335 7.68389M6.42621 4.03116L8.81185 4.03116M15.9688 13.5737V11.1881M8.81185 4.03116L10.8271 4.03845C12.7253 4.04533 13.6737 6.33819 12.335 7.68389V7.68389M15.9688 11.1881L15.9533 9.16098C15.939 7.27978 13.6617 6.35013 12.335 7.68389V7.68389",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_800_1664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.a81cea33d6049c0c57afa438527c86e8.svg";
export { ForwardRef as ReactComponent };